/**
 * Tipos de documento de suporte canabinoide.
 * `categoryValue` = id estável (code FHIR); `categoryDisplay` = título legível.
 */
export type PatientSupportingDocumentTypeId =
  | "anvisa_import_authorization"
  | "medical_prescription"
  | "personal_document"
  | "proof_of_residence";

export interface PatientSupportingDocumentCategory {
  value: PatientSupportingDocumentTypeId;
  display: string;
}

/**
 * Mapa typeId → category FHIR.
 * value = typeId (code estável); display = título usado na UI.
 */
export const PATIENT_SUPPORTING_DOCUMENT_CATEGORIES: Record<
  PatientSupportingDocumentTypeId,
  PatientSupportingDocumentCategory
> = {
  anvisa_import_authorization: {
    value: "anvisa_import_authorization",
    display: "Autorização Anvisa",
  },
  medical_prescription: {
    value: "medical_prescription",
    display: "Receita médica",
  },
  personal_document: {
    value: "personal_document",
    display: "Documento pessoal",
  },
  proof_of_residence: {
    value: "proof_of_residence",
    display: "Comprovante de residência",
  },
};

export function getCategoryForTypeId(
  typeId: PatientSupportingDocumentTypeId,
): PatientSupportingDocumentCategory {
  return PATIENT_SUPPORTING_DOCUMENT_CATEGORIES[typeId];
}

/**
 * Extrai base64 puro de data URL (`data:mime;base64,...`) ou devolve a string se já for pura.
 */
export function extractBase64FromDataUrl(dataUrlOrBase64: string): string {
  const trimmed = dataUrlOrBase64.trim();
  const marker = "base64,";
  const index = trimmed.indexOf(marker);
  if (index >= 0) {
    return trimmed.slice(index + marker.length);
  }
  return trimmed;
}
